
<router-outlet></router-outlet>
<app-session-conflict-modal></app-session-conflict-modal>

<!-- Banner global configurável (warning | success | desativado) -->
<ng-container *ngIf="bannerType">

  <!-- Card expandido (posicionado acima do botão circular) -->
  <div *ngIf="bannerExpanded" class="fixed z-[2147483002] transition-all duration-300"
       style="bottom: 80px; right: 20px;">

    <!-- MODELO WARNING -->
    <div *ngIf="bannerType === 'warning'" class="bg-white rounded-lg shadow-xl border-l-4 border-red-500 overflow-hidden cursor-pointer w-[calc(100vw-2rem)] sm:w-96" (click)="toggleBannerExpanded()">
      <div class="px-4 py-3 flex items-start gap-3">
        <svg class="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
        </svg>
        <div class="flex-1 min-w-0">
          <h4 class="text-gray-900 font-semibold text-sm">Aviso Importante</h4>
          <p class="text-gray-600 text-sm leading-relaxed mt-1" [innerHTML]="bannerMessage"></p>
          <ul *ngIf="bannerDetails.length" class="text-gray-600 text-sm leading-relaxed list-disc pl-4 mt-2 space-y-1.5">
            <li *ngFor="let detail of bannerDetails" [innerHTML]="detail"></li>
          </ul>
        </div>
        <svg class="w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
        </svg>
      </div>
    </div>

    <!-- MODELO SUCCESS -->
    <div *ngIf="bannerType === 'success'" class="bg-white rounded-lg shadow-xl border-l-4 border-emerald-500 overflow-hidden cursor-pointer w-[calc(100vw-2rem)] sm:w-80" (click)="toggleBannerExpanded()">
      <div class="px-4 py-3 flex items-start gap-3">
        <svg class="w-6 h-6 text-emerald-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
        </svg>
        <div class="flex-1 min-w-0">
          <h4 class="text-gray-900 font-semibold text-sm">Tudo Normalizado</h4>
          <p class="text-gray-600 text-sm leading-relaxed mt-1" [innerHTML]="bannerMessage"></p>
        </div>
        <svg class="w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
        </svg>
      </div>
    </div>
  </div>

  <!-- Botão circular minimizado (cópia exata do estilo Intercom launcher) -->
  <button *ngIf="!bannerExpanded" (click)="toggleBannerExpanded()"
    class="fixed z-[2147483002] flex items-center justify-center cursor-pointer border-0 p-0 m-0"
    [ngStyle]="{
      'bottom': '20px',
      'right': '84px',
      'width': '48px',
      'max-width': '48px',
      'height': '48px',
      'max-height': '48px',
      'border-radius': '50%',
      'background': bannerType === 'warning' ? '#ef4444' : '#10b981',
      'box-shadow': '0 1px 6px 0 rgba(0,0,0,0.06), 0 2px 32px 0 rgba(0,0,0,0.16)',
      'box-sizing': 'content-box',
      'transition': 'transform 167ms cubic-bezier(0.33, 0.00, 0.00, 1.00)'
    }"
    onmouseenter="this.style.transform='scale(1.1)'"
    onmouseleave="this.style.transform='scale(1)'">
    <!-- Ícone warning -->
    <svg *ngIf="bannerType === 'warning'" class="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
      <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
    </svg>
    <!-- Ícone success -->
    <svg *ngIf="bannerType === 'success'" class="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
    </svg>
  </button>

</ng-container>
